/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* tslint:disable: no-duplicate-imports this is a change */
import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import classnames from 'classnames';
import { reaction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import  { getAttributesForSelectedVariant } from '@msdyn365-commerce-modules/product-specification';
import  { AttributesForSelectedVariantInput } from '@msdyn365-commerce-modules/product-specification';


//import { ProductSpecificationTableRow } from './components/obrien-prop65-table-stucture';
import { IObrienProp65Data } from './obrien-prop65.data';
import { IObrienProp65Props } from './obrien-prop65.props.autogenerated';

export interface IProductSpecificationViewProps extends IObrienProp65Props<{}> {
    ProductSpecification: IModuleProps;
    ProductSpecificationTableProps: INodeProps;
    ProductSpecificationTableBodyProps: INodeProps;
    productSpecificationResult?: (JSX.Element | null)[];
    title?: React.ReactNode;
    onlinetitle?: React.ReactNode;
    

}

/**
 *
 * ProductSpecification component
 * @extends {React.Component<IObrienProp65Props<IObrienProp65Data>>}
 */
@observer
class ProductSpecification extends React.Component<IObrienProp65Props<IObrienProp65Data>> {
    public async componentDidMount(): Promise<void> {
        const { context, data, telemetry } = this.props;

        // @ts-ignore: Compiler not reconizing condition check for function params
        reaction(
            () => (data.product.result ? data.product.result.RecordId : null),
            () => {
                if (context && data.product.result) {
                    //@ts-ignore
                    const actionInput = new AttributesForSelectedVariantInput(
                        data.product.result.RecordId,
                        // @ts-ignore
                        +context.actionContext.requestContext.apiSettings.channelId,
                        data.product.result
                    );
                        //@ts-ignore
                    getAttributesForSelectedVariant(actionInput, this.props.context.actionContext).catch(error => {
                        telemetry.warning(error);
                        telemetry.debug('Unable to update attributes for Product');
                        telemetry.error(error);
                    });
                }
            }
        );
    }

    // tslint:disable-next-line:max-func-body-length
    public render(): JSX.Element | null {
        let data: IObrienProp65Data;

        try {
            data = this.props.data;
        } catch (e) {
            this.props.telemetry.error(`Something went wrong ------${e}`);
            //@ts-ignore
            return <div>{e}</div>;
        }

        if (!data.productSpecificationData.result || data.productSpecificationData.result.length <= 0) {
            this.props.telemetry.error('Product specification content is empty, module wont render.');
            return null;
        }

        const { className } = this.props.config;

        

        
        const { productSpecificationData } = this.props.data;

        const viewProps = {
            ...this.props,
            

            ProductSpecification: {
                moduleProps: this.props,
                className: classnames('locally', className)
            },
            ProductSpecificationTableProps: {
                className: classnames('nick-test'),
                tag: 'span'
            },
            ProductSpecificationTableBodyProps: {
                className: '',
                tag: 'div'
            },
            //@ts-ignore
            productSpecificationResult: productSpecificationData && this._createTableBody(data)
        } as IProductSpecificationViewProps;

        return this.props.renderView(viewProps) as React.ReactElement;
    }
    
    private _createTableBody(content: IObrienProp65Data): (JSX.Element | null)[] {
        return content.productSpecificationData.result!.map((product, index) => {
            const cellData: JSX.Element | null = this._renderProductCell(product);

            if (!cellData) {
                return null;
            }
            
            if (product.TextValue === "Diisononyl Phthalate") {

                const warningOne = `<h3>Prop 65 Warning: Diisononyl Phthalate (DINP)</h3>
                <div class="field__item"><div class="paragraph paragraph--type--warning paragraph--view-mode--default factsheet-item theme--warning">
                  <div class="factsheet-item__title field__item">Why am I being warned about potential exposure to DINP?</div>
                    <div class="factsheet-item__content field__item">
                        <ul>
                            <li>DINP is on the&nbsp;<a href="https://www.p65warnings.ca.gov/faq">Proposition 65</a>&nbsp;list because it can cause cancer.</li>
                            <li>Exposure to DINP may increase the risk of cancer.</li>
                            <li>Proposition 65 requires businesses to determine if they must provide a warning about exposures to&nbsp;<a href="https://www.p65warnings.ca.gov/chemicals">listed chemicals</a>.</li>
                        </ul>
                    </div>
                  </div>
                </div>
                `;

                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: warningOne, }} />

                );
            }
            if (product.TextValue === "DI-N-HEXYL PHTHALATE") {

                const warningTwo = `<h3>Prop 65 Warning: Di-n-hexyl Phthalate (DnHP)</h3>
                <div class="field__item"><div class="paragraph paragraph--type--warning paragraph--view-mode--default factsheet-item theme--warning">
                  <div class="factsheet-item__title field__item">Why am I being warned about potential exposure to DnHP?</div>
                    <div class="factsheet-item__content field__item">
                        <ul>
                            <li>DnHP is on the&nbsp;<a href="https://www.p65warnings.ca.gov/faq">Proposition 65</a>&nbsp;list because it can cause birth defects or other reproductive harm.&nbsp;</li>
                            <li>Exposure to DnHP may harm the male and female reproductive systems.&nbsp;</li>
                            <li>Proposition 65 requires businesses to determine if they must provide a warning about exposure to&nbsp;<a href="https://www.p65warnings.ca.gov/chemicals">listed chemicals</a>.</li>
                        </ul>
                    </div>
                  </div>
                </div>
                `;

                return (
                    
                    <div className="fifty" dangerouslySetInnerHTML={{ __html: warningTwo, }} />

                );
            }


            return (
                null
            );
        });
    }

    private _renderProductCell(product: AttributeValue): JSX.Element | null {
        switch (product.DataTypeValue) {
            case 0: // none
                // Return span here instead of null so the row still shows
                return <span />;
            case 1: // Currency
                return this._renderCurrencyCell(product);
            case 2: // DateTime
                return this._renderDateTimeCell(product);
            case 3: // Decimal
                return this._renderDecimalCell(product);
            case 4: // Integer
                return this._renderIntegerCell(product);
            case 5: // Text
                return this._renderTextCell(product);
            case 6: // TrueFalse
                return this._renderTrueFalseCell(product);
            case 40: // Video
                this.props.telemetry.warning('Got video specification type, not supported yet so skipping line');
                return null;
            case 41: // Image
                this.props.telemetry.warning('Got image specification type, not supported yet so skipping line');
                return null;
            default:
                this.props.telemetry.warning(`Got unknown specification type ${product.DataTypeValue} so skipping line`);
                return null;
        }
    }

    private _renderCurrencyCell(product: AttributeValue): JSX.Element | null {
        if (product.CurrencyValue !== null && product.CurrencyValue !== undefined) {
            return (
                <span>
                    {product.CurrencyCode}
                    {product.CurrencyValue}
                </span>
            );
        }

        return null;
    }

    private _renderDateTimeCell(product: AttributeValue): JSX.Element | null {
        if (product.DateTimeOffsetValue !== null && product.DateTimeOffsetValue !== undefined && product.DateTimeOffsetValue.toUTCString) {
            return <span>{product.DateTimeOffsetValue.toUTCString()}</span>;
        }

        return null;
    }

    private _renderIntegerCell(product: AttributeValue): JSX.Element | null {
        if (product.IntegerValue !== null && product.IntegerValue !== undefined) {
            return <span>{product.IntegerValue}</span>;
        }

        return null;
    }

    private _renderDecimalCell(product: AttributeValue): JSX.Element | null {
        if (product.FloatValue !== null && product.FloatValue !== undefined) {
            return <span>{product.FloatValue}</span>;
        }

        return null;
    }

    private _renderTextCell(product: AttributeValue): JSX.Element | null {
        if (product.TextValue !== null && product.TextValue !== undefined) {
            // tslint:disable-next-line
            return <span dangerouslySetInnerHTML={Msdyn365.getRichTextHtml(product.TextValue)}/>;
        }

        return null;
    }

    private _renderTrueFalseCell(product: AttributeValue): JSX.Element | null {
        // TODO 20369885 setting to default value is needed to work around a platform bug where
        // config string value does not get its default value.
        if (product.BooleanValue) {
            return <span>{this.props.resources.trueValueText ? this.props.resources.trueValueText : 'Yes'}</span>;
        } else {
            return <span>{this.props.resources.falseValueText ? this.props.resources.falseValueText : 'No'}</span>;
        }
    }
}

export default ProductSpecification;
